import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, identityProvider }) =>
    present(
      repository
        .removeIdentityProvider(planzone, identityProvider)
        .then(() => ({
          planzone,
          identityProvider,
        }))
        .catch(() => Promise.reject({ planzone, identityProvider })),
    );
}

export type { Interactor };

export { createInteractor };
